import { createApp } from '@backstage/frontend-defaults';
import catalogPlugin from '@backstage/plugin-catalog/alpha';
import { appModuleSignInPage } from './appModuleSignInPage';
import { databaseCredentialsPageModule } from './databaseCredentialsPage';
import { navModule } from './modules/nav';
import { translationsModule } from './translations/module';

export default createApp({
  features: [
    catalogPlugin,
    navModule,
    appModuleSignInPage,
    databaseCredentialsPageModule,
    translationsModule,
  ],
});
